export default {
  common: {
    form: {
      save: "Save",
      requiredText: "* = field is mandatory",
      required: "Field is mandatory",
      requiredEmail: "Email is mandatory",
      validEmail: "Email address not valid"
    },
    actions: {
      logout: "Logout",
      administration: "Administration",
      mainAdministration: "Main administration",
      delete: "Delete"
    },
    list: {
      actions: "Actions",
    },
    propPanel: {
      save: "Save"
    },
    labels: {
      close: "Close"
    }
  },

  login: {
    form: {
      title: "Login",
      username: "User/Benutzername",
      password: "Password/Passwort",
      submit: "Login/Einloggen",
    },
  },

  visitor: {
    form:  {
      title: "Register",
      name: "Name",
      adr: "Address",
      company: "Company",
      email: "E-Mail address",
      submit: "Submit"
    }
  },

  logout: {
    pageTitle: "Logged out",
    body: "You are now logged out.",
    backToLogin: "Back to login",
  },

  question: {
    title: "Add question",
    form: {
      title: "Title",
      author: "Author",
      body: "Question",
      link: "Link",
    },
    added: "Question added",
    missingContent: "Title and body can not be empty"
  },

  vote:  {
    title: "Vote"
  },

  admin: {
    nav: {
      home: "Home",
      adminHome: "Admin home",
      userManagement: "User management",
      customerManagement: "Customer management",
      qTimes: "Question filters"
    },
    section: {
      customers: "Customers",
    },
    userManagement: {
      addUser: "Add user",
      pageTitle: "User management",
      importUsers: "Import users"
    },
    customerManagement: {
      pageTitle: "Customer management",
      addCustomer: "Add customer"
    },
    qTimes: {
      pageTitle: "Question filters",
      addTime: "Add filter"
    }
  },

  customers: {
    list:{
      name: "Customer name",
      playerUrl: "Player url",
      description: "Description"
    }
  },

  users: {
    list: {
      name: "Name",
      email: "Email",
      state: "Status",
      role: "Role",
      customer: "Customer",
      lastLoginDate: "Last login",
      lang: "Language"
    },
    edit:{
      password: {
        title: "Set password",
        password: "Password",
        passwordValidation: "Password verification",
        showPasswordInClear: "Show pasword in clear",
        change: {
          submit: "Save"
        }
      }
    },
    delete: {
      confirmMessage: "Do you realy want to delete this user?"
    }
  },

  home: {
    addQuestion: "Ask question"
  },

  customer: {
    nav: {
      home: {
        default: "Player",
        de: "Player de",
        en: "Player en"
      },
      view: "View",
      adminHome: "Admin home",
      questionList: "Question management",
      voteList: "Vote management",
      register: "Register"
    },
    admin:{
      info:{
        title: "Welcome to the administration part",
        body: ""
      },
      questions:{
        title: "Question liste",
        add: "Add question"
      },
      votes: {
        title: "Vote liste",
        add: "Add vote",
        total: "Total votes",
        state: "Vote active",
        details: "Details"
      }
    },
    votes: {
      yes: "Yes",
      no: "No",
      abstention: "Abstain",
    }
  },

  qTimes:{
    list: {
      name: "Filter name",
      customer: "Customer",
      from: "Valid From",
      to: "Valid until"
    },
    delete: {
      confirmMessage: "Realy delete?"
    }
  }
};
